/* eslint-disable no-loop-func */
import { useState, useEffect, useRef } from 'react';
import { useMap } from "react-leaflet";
import { useDispatch, useSelector } from 'react-redux';
import { setNewMapState } from "../../mapSlice";
import L from "leaflet";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export default function CustomTileLayer({ isPlaying, frame, spanHours }) {
  const dispatch = useDispatch();
  const [layersArr, setLayersArr] = useState([]);
  // const [initTime, setInitTime] = useState('');
  // const layersFromStore = useSelector(state => state.map.layersArr);
  // const frame = useSelector(state => state.map.frame);
  const isLoading = useSelector(state => state.map.isLoading);
  const initTime = useSelector(state => state.map.initTime);

  const map = useMap();

  const CW_MAPS_BETA_KEY = process.env.REACT_APP_MAPS_BETA_KEY;


  useEffect(() => {
    const CW_CLIENT = process.env.REACT_APP_CLIENT;
    const CW_PASSWORD = process.env.REACT_APP_CLIENT_PASSWORD;

    const getInitTime = async () => {
      const initTimeUrl = `https://cws.customweather.com/xml?client=${CW_CLIENT}&client_password=${CW_PASSWORD}&product=cws&source=gfs0p25hourly&cws.layer=precip_1hr&cws.level=sfc&cws.init_time=latest&id=KSFO&start=0&end=0&format=json`;

      try {
        const response = await fetch(initTimeUrl);
        const data = await response.json();
        if (initTime.length < 1) {
          dispatch(setNewMapState({ initTime: data[0].model[0].time.init_utc }))
          // setInitTime(data[0].model[0].time.init_utc);
        }
      } catch (error) {
        console.error(error);
      }
    };
    getInitTime();
  }, [initTime, dispatch])



  function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }

  useEffect(() => {
    const timesArr = [];
    for (let i = 0; i < spanHours; i++) {
      const startTime = dayjs(oneHourAgo()).add(i, 'h').local().format('MM/DD/YYYY hh:mma z');
      // const addedTime = addHours(i, startTime);
      timesArr.push(startTime);
    }
    dispatch(setNewMapState({ layersArr: timesArr }))
  }, [dispatch, spanHours, initTime]);

  // Add hours to current time
  // const addHours = (hours, _initTime) => {
  //   let now = _initTime ? new Date(_initTime) : new Date();
  //   now.setTime(now.getTime() + (hours * 60 * 60 * 1000));
  //   now.setMinutes(0);
  //   now.setSeconds(0);
  //   now.setMilliseconds(0);
  //   return now;
  // }

  const updateLayer = () => {
    let mapIterator = 0;
    map.eachLayer((layer) => {
      if (layer.options.fxTime) {
        if (mapIterator === frame) {
          layer.setOpacity(0.6);
        } else {
          layer.setOpacity(0.0);
        }
        map.getBounds();
      }
      mapIterator++;
    });
  };

  const oneHourAgo = () => {
    let now = dayjs.utc().subtract(1, 'h').minute(0).second(0);
    return now;
  };

  // Build array of transparent tile layers
  const tempArr = [];
  let layersLoaded = 0;

  for (let i = 0; i < spanHours; i++) {
    // const addedTime = addHours(i);
    const addedTime = dayjs(oneHourAgo()).add(i, 'h').utc().format();

    const testUrl = `https://maps-beta.customweather.com/smt/${CW_MAPS_BETA_KEY}/cws/gfs0p25hourly/precip_1hr/sfc/latest/${addedTime}/{z}/{x}/{y}.png`;
    const precipLayer = L.tileLayer(testUrl, { opacity: 0.0, zIndex: 9999, fxTime: addedTime });
    precipLayer.on('loading', () => {
      if (!isLoading) {
        dispatch(setNewMapState({ isLoading: true }));
      }
    });
    precipLayer.on('load', () => {
      layersLoaded += 1;
      if (isLoading && layersLoaded >= spanHours) {
        dispatch(setNewMapState({ isLoading: false }));
      }
    });
    tempArr.push(precipLayer);
  }

  if (layersArr.length < 1) {
    setLayersArr(tempArr);
  }

  // Add each layer to map if map has less than 8 layers 
  layersArr.forEach((layer, idx) => {
    if (idx === frame) {
      layer.setOpacity(1);
    }
    if (Object.keys(map._layers).length < spanHours) {
      map.addLayer(layer);
    }
  });
  updateLayer();

  useInterval(() => {
    updateLayer();

    if (frame < spanHours - 1) {
      dispatch(setNewMapState({ frame: frame + 1 }));
    } else {
      dispatch(setNewMapState({ frame: 0 }));
    }

  }, isPlaying ? 500 : null);

  return null;
}
